import { useState } from "react";
import { Link } from "react-router-dom";

const MARKETING_EMAIL = "marketing@trangile.com";

const EMPTY_FORM = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
};

const ShowInterest = () => {
    const [formData, setFormData] = useState(EMPTY_FORM);
    const [error, setError] = useState("");
    const [sent, setSent] = useState(false);

    const onChange = (event) => {
        const { id, value } = event.target;
        setFormData((current) => ({ ...current, [id]: value }));
        if (error) setError("");
    };

    const onSubmit = (event) => {
        event.preventDefault();
        const firstName = formData.firstName.trim();
        const lastName = formData.lastName.trim();
        const email = formData.email.trim();
        const phone = formData.phone.trim();
        const message = formData.message.trim();

        if (!firstName || !lastName || !email || !phone || !message) {
            setError("Complete each field so marketing can reply.");
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setError("Enter a valid email address.");
            return;
        }

        const subject = `Show interest — ${firstName} ${lastName}`;
        const body = [
            "New interest enquiry",
            "",
            `Name: ${firstName} ${lastName}`,
            `Email: ${email}`,
            `Phone: ${phone}`,
            "",
            "Message:",
            message,
        ].join("\n");

        const mail = document.createElement("a");
        mail.href = `mailto:${MARKETING_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        mail.rel = "noopener";
        mail.click();
        setSent(true);
    };

    return (
        <div className="interest-page">
            <section className="interest-story" aria-label="Partner with Trangile">
                <div className="interest-logo-frame">
                    <img src="/logoWhite.jpg" alt="Trangile" className="interest-logo" />
                </div>
                <div className="interest-story-body">
                    <p className="interest-kicker">Marketing</p>
                    <h1>Show your interest in the partner portal.</h1>
                    <p className="interest-story-copy">
                        Tell us about your operation. The marketing team reviews every enquiry and replies from a single desk.
                    </p>
                    <ul className="interest-points">
                        <li>
                            <i className="bi bi-briefcase" aria-hidden="true"></i>
                            Partnership conversations, not a ticket queue
                        </li>
                        <li>
                            <i className="bi bi-diagram-3" aria-hidden="true"></i>
                            Built for purchase, shipping, and receipt teams
                        </li>
                        <li>
                            <i className="bi bi-shield-check" aria-hidden="true"></i>
                            A direct line to marketing@trangile.com
                        </li>
                    </ul>
                    <a className="interest-direct" href={`mailto:${MARKETING_EMAIL}`}>
                        <i className="bi bi-envelope" aria-hidden="true"></i>
                        <span>
                            <small>Write directly</small>
                            <strong>{MARKETING_EMAIL}</strong>
                        </span>
                    </a>
                </div>
            </section>

            <section className="interest-panel">
                <div className="interest-card">
                    {sent ? (
                        <div className="interest-success">
                            <div className="interest-success-mark" aria-hidden="true">
                                <i className="bi bi-envelope-check"></i>
                            </div>
                            <p className="interest-kicker interest-kicker-dark">Ready to send</p>
                            <h2>Your enquiry is addressed to marketing</h2>
                            <p>
                                Your mail app should open with a message to {MARKETING_EMAIL}. Send it from there and the team will reply to {formData.email.trim()}.
                            </p>
                            <button type="button" className="interest-submit" onClick={() => setSent(false)}>
                                Edit details
                            </button>
                            <Link to="/login" className="interest-back">Back to sign in</Link>
                        </div>
                    ) : (
                        <form onSubmit={onSubmit} noValidate>
                            <p className="interest-kicker interest-kicker-dark">Enquiry</p>
                            <h2>Tell us how we can help</h2>
                            <p className="interest-lead">
                                The fields below are included in the email sent to marketing.
                            </p>

                            <div className="interest-destination">
                                <span>
                                    <small>Send to</small>
                                    <a href={`mailto:${MARKETING_EMAIL}`}>{MARKETING_EMAIL}</a>
                                </span>
                                <i className="bi bi-send" aria-hidden="true"></i>
                            </div>

                            <div className="interest-grid">
                                <label className="interest-field" htmlFor="firstName">
                                    <span>First name</span>
                                    <input
                                        id="firstName"
                                        type="text"
                                        autoComplete="given-name"
                                        placeholder="Aanya"
                                        value={formData.firstName}
                                        onChange={onChange}
                                        required
                                    />
                                </label>
                                <label className="interest-field" htmlFor="lastName">
                                    <span>Last name</span>
                                    <input
                                        id="lastName"
                                        type="text"
                                        autoComplete="family-name"
                                        placeholder="Shah"
                                        value={formData.lastName}
                                        onChange={onChange}
                                        required
                                    />
                                </label>
                                <label className="interest-field" htmlFor="email">
                                    <span>Your email</span>
                                    <input
                                        id="email"
                                        type="email"
                                        autoComplete="email"
                                        placeholder="name@company.com"
                                        value={formData.email}
                                        onChange={onChange}
                                        required
                                    />
                                </label>
                                <label className="interest-field" htmlFor="phone">
                                    <span>Phone</span>
                                    <input
                                        id="phone"
                                        type="tel"
                                        inputMode="tel"
                                        autoComplete="tel"
                                        placeholder="+91 98765 43210"
                                        value={formData.phone}
                                        onChange={onChange}
                                        required
                                    />
                                </label>
                                <label className="interest-field interest-span" htmlFor="message">
                                    <span>Message</span>
                                    <textarea
                                        id="message"
                                        rows="4"
                                        placeholder="What would you like to explore with the partner portal?"
                                        value={formData.message}
                                        onChange={onChange}
                                        required
                                    />
                                </label>
                            </div>

                            {error ? (
                                <p className="interest-error" role="alert">{error}</p>
                            ) : null}

                            <button type="submit" className="interest-submit">
                                Send to marketing
                            </button>
                            <Link to="/login" className="interest-back">Back to sign in</Link>
                        </form>
                    )}
                </div>
            </section>
        </div>
    );
};

export default ShowInterest;
